
import { Component, Vue } from "vue-property-decorator";
import BackgroundLoader from "@/components/Common/BackgroundLoader.vue";
import MenuPrincipal from "@/components/Menus/MenuPrincipal.vue";


@Component({
  components: {
    BackgroundLoader,
    MenuPrincipal,
  }
})
export default class ContactoPlayer extends Vue {

  public frame_contacto = "6_0_contacto.svg";
  public backgroundRef = this.frame_contacto;

  // mounted() {
  //   console.log("contactoPlayer mounted " + this.$store.state.mainState)
  // }

  public get source(): string {
    return this.frame_contacto;
  }

  sendMail() {
    // console.log("sendMail");
    const win: Window = window;
    win.location = "mailto:ingo@ingenieriahumana.es";
  }

    get texto() {
    return `<div class="texto-rojo" style="transform: scaleX(1.05); transform-origin: top left;">
        M. (+34) 606 45 17 22
        <br/>
        T / F. (+34) 91 872 50 74
      </div>
      <div class="texto-rojo" style="transform: scaleX(.95); transform-origin: top left;">
        <br/>
        info@ingenieriahumana.es
      </div>`;
  }

  get clase() {
    return "texto-contactos";
  }


}

